import React, { useState, useEffect } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import AuthButton from './components/AuthButton';
import Home from './pages/Home';
import EventsList from './components/EventsList';
import EventDetail from './pages/EventDetail';
import VenueDetail from './pages/VenueDetail';
import SportsPage from './pages/SportsPage';
import BirthdayVenuesPage from './pages/BirthdayVenuesPage';
import ClassesPage from './pages/ClassesPage';
import CampsPage from './pages/CampsPage';
import AttractionsPage from './pages/AttractionsPage';
import FavoritesPage from './pages/FavoritesPage';
import UserPreferences from './pages/UserPreferences';
import SchoolDistrictsPage from './pages/SchoolDistrictsPage';
import AuthCallback from './pages/AuthCallback';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AboutUs from './pages/AboutUs';

function App() {
  const [selectedCity, setSelectedCity] = useState<string>('Houston');

  useEffect(() => {
    const savedCity = localStorage.getItem('selectedCity');
    if (savedCity) {
      setSelectedCity(savedCity);
    }
  }, []);
  return (
    <ErrorBoundary>
      <AuthProvider>
        <div className="App">
        <header className="App-header">
          <div className="header-content">
            <div className="header-left">
              <Link to="/" className="logo-link">
                <img src="/logo.jpg" alt="Jollyio - Discover kid-friendly events near you" className="logo" />
              </Link>
              <div className="header-text">
                <h1>Discover Kid-Friendly Events Near You</h1>
                <p className="tagline">
                  Your guide for kids events, camps, classes and much more
                </p>
              </div>
            </div>
            <div className="header-right">
              <AuthButton />
            </div>
          </div>
        </header>
        <main className="App-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<EventsList />} />
            <Route path="/event/:slug" element={<EventDetail />} />
            <Route path="/venue/:slug" element={<VenueDetail />} />
            <Route path="/birthday-parties" element={<BirthdayVenuesPage />} />
            <Route path="/classes" element={<ClassesPage />} />
            <Route path="/camps" element={<CampsPage />} />
            <Route path="/sports" element={<SportsPage />} />
            <Route path="/attractions" element={<AttractionsPage />} />
            <Route path="/school-districts" element={<SchoolDistrictsPage />} />
            <Route path="/favorites" element={<FavoritesPage />} />
            <Route path="/preferences" element={<UserPreferences />} />
            <Route path="/auth-callback" element={<AuthCallback />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/about" element={<AboutUs />} />
          </Routes>
        </main>
        <footer className="App-footer">
          <div className="footer-content">
            <div className="footer-section">
              <h4>Jollyio</h4>
              <p>Your guide for kid-friendly events in {selectedCity}</p>
            </div>
            <div className="footer-section">
              <h4>Company</h4>
              <a href="/about">About Us</a>
              <a href="/terms">Terms of Service</a>
              <a href="/privacy">Privacy Policy</a>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <a href="mailto:support@jollyio.com">support@jollyio.com</a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© 2026 Jollyio. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </AuthProvider>
  </ErrorBoundary>
  );
}

export default App;
